import { MessageDescriptor } from "react-intl";

/**
 * What react-intl's defineMessages did before version 12: hand the messages back, for the
 * sake of the tooling that reads them out of the source.
 *
 * Version 12 also marks each descriptor with the placeholders its defaultMessage
 * contains, and refuses values that the mark does not list. The messages here carry no
 * defaultMessage - the translations live in the token table, and the ids are all the
 * source has - so every mark would be empty and every value an error.
 */
const defineMessages = <T extends Record<string, MessageDescriptor>>(messages: T): T => messages;

export default defineMessages;
